/** Tiles on each side of the minimap, and CSS pixels a tile, small or enlarged (SHE-37). */
export interface MinimapLayout {
  view: number;
  scale: 1 | 2;
}

export const SMALL_VIEW = 128;
/** On a phone, an enlarged minimap shows fewer tiles so it stays clear of the top-right buttons (390×664) and of the chat (750×342). */
export const TOUCH_LARGE_VIEW = 80;

const LARGE_KEY = 'shefira.minimap-large';

export function minimapLayout(large: boolean, touch: boolean): MinimapLayout {
  if (!large) return { view: SMALL_VIEW, scale: 1 };
  return { view: touch ? TOUCH_LARGE_VIEW : SMALL_VIEW, scale: 2 };
}

/** Whether the player left the minimap enlarged, in this browser. */
export function readMinimapLarge(): boolean {
  try {
    return localStorage.getItem(LARGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function saveMinimapLarge(large: boolean): void {
  try {
    localStorage.setItem(LARGE_KEY, large ? '1' : '0');
  } catch {
    /* enlarged for this visit only */
  }
}
